import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-pdpa-policy',
  templateUrl: './pdpa-policy.component.html',
  styleUrls: ['./pdpa-policy.component.scss'],
})
export class PDPAPolicyComponent implements OnInit {

  otpForm: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
  }
}
